/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetApiV3ImagesProposalsProposalIdPngRequest = {
  proposalId: number;
};

/** @internal */
export const GetApiV3ImagesProposalsProposalIdPngRequest$inboundSchema:
  z.ZodType<
    GetApiV3ImagesProposalsProposalIdPngRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    proposal_id: z.number().int(),
  }).transform((v) => {
    return remap$(v, {
      "proposal_id": "proposalId",
    });
  });

/** @internal */
export type GetApiV3ImagesProposalsProposalIdPngRequest$Outbound = {
  proposal_id: number;
};

/** @internal */
export const GetApiV3ImagesProposalsProposalIdPngRequest$outboundSchema:
  z.ZodType<
    GetApiV3ImagesProposalsProposalIdPngRequest$Outbound,
    z.ZodTypeDef,
    GetApiV3ImagesProposalsProposalIdPngRequest
  > = z.object({
    proposalId: z.number().int(),
  }).transform((v) => {
    return remap$(v, {
      proposalId: "proposal_id",
    });
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3ImagesProposalsProposalIdPngRequest$ {
  /** @deprecated use `GetApiV3ImagesProposalsProposalIdPngRequest$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3ImagesProposalsProposalIdPngRequest$inboundSchema;
  /** @deprecated use `GetApiV3ImagesProposalsProposalIdPngRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3ImagesProposalsProposalIdPngRequest$outboundSchema;
  /** @deprecated use `GetApiV3ImagesProposalsProposalIdPngRequest$Outbound` instead. */
  export type Outbound = GetApiV3ImagesProposalsProposalIdPngRequest$Outbound;
}

export function getApiV3ImagesProposalsProposalIdPngRequestToJSON(
  getApiV3ImagesProposalsProposalIdPngRequest:
    GetApiV3ImagesProposalsProposalIdPngRequest,
): string {
  return JSON.stringify(
    GetApiV3ImagesProposalsProposalIdPngRequest$outboundSchema.parse(
      getApiV3ImagesProposalsProposalIdPngRequest,
    ),
  );
}

export function getApiV3ImagesProposalsProposalIdPngRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiV3ImagesProposalsProposalIdPngRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiV3ImagesProposalsProposalIdPngRequest$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'GetApiV3ImagesProposalsProposalIdPngRequest' from JSON`,
  );
}
